<template>
    <ml-layout title="实践教学管理平台" :nav="nav">
        <div class="ml-main">
            <el-carousel trigger="click" class="banner" height="322px">
                <el-carousel-item v-for="(item, index) in banner" :key="index">
                    <ml-image :src="item" />
                </el-carousel-item>
            </el-carousel>
            <el-row :gutter="40">
                <el-col :span="6">
                    <ml-column title="常用工具">
                        <el-button
                            type="primary"
                            size="small"
                            class="more-tools"
                            @click="handleGo('manager')"
                        >
                            虚拟仿真实验教学平台
                        </el-button>
                        <!-- <el-button
                            type="primary"
                            size="small"
                            class="more-tools"
                            @click="handleGo('lab')"
                        >
                            实验室管理平台
                        </el-button> -->
                        <el-button
                            type="primary"
                            size="small"
                            class="more-tools"
                            @click="handleGo('caselibrary')"
                        >
                            真实项目案例库
                        </el-button>

                        <el-button
                            type="primary"
                            size="small"
                            class="more-tools"
                            @click="handleGo('base')"
                        >
                            实践教育基地管理
                        </el-button>
                    </ml-column>
                </el-col>
                <el-col :span="9">
                    <ml-column title="综合新闻">
                        <ml-notice
                            :date="
                                (() => {
                                    return item.addtime.slice(0, 10);
                                })()
                            "
                            v-for="item in news"
                            :key="item.id"
                            :link="'news?id=' + item.id"
                        >
                            {{ item.title }}
                        </ml-notice>
                    </ml-column>
                </el-col>
                <el-col :span="9">
                    <ml-column title="虚拟实验平台公告">
                        <ml-notice
                            :date="
                                (() => {
                                    return item.addtime.slice(0, 10);
                                })()
                            "
                            v-for="item in notice"
                            :key="item.id"
                            :link="'notice?id=' + item.id"
                        >
                            {{ item.title }}
                        </ml-notice>
                    </ml-column>
                </el-col>
            </el-row>
            <ml-column title="虚拟实验" more="/virtualExp">
                <el-row v-for="i in virtualExpRow" :key="i">
                    <el-col :span="8" v-for="j in 3" :key="j">
                        <ml-card
                            v-if="[(i - 1) * 3 + j - 1] < virtualExpList.length"
                            :info="virtualExpList[(i - 1) * 3 + j - 1]"
                        ></ml-card>
                    </el-col>
                </el-row>
            </ml-column>
            <ml-column title="最新实验" more="/virtualExp">
                <el-row>
                    <el-col :span="8" v-for="i in newVirtualExpCol" :key="i">
                        <ml-card :info="newVirtualExpList[i - 1]"></ml-card>
                    </el-col>
                </el-row>
            </ml-column>
        </div>
    </ml-layout>
</template>

<script>
import {
    showVirtualSimulation,
    getFontendNewsList,
    getFontendNoticeList,
} from "@/api/views/home";

import MlImage from "@/components/MlImage";
import MlLayout from "@/components/MlLayout";
import MlCard from "@/components/MlCard";
import MlColumn from "@/components/MlColumn";
import MlNotice from "@/components/MlNotice";

export default {
    name: "Home",
    components: {
        MlImage,
        MlLayout,
        MlCard,
        MlColumn,
        MlNotice
    },
    data() {
        return {
            nav: [
                { title: "首页", path: ["/"] },
                { title: "虚拟实验", path: ["/virtualExp", "/declareExp"] }
            ],
            banner: [],
            virtualExpList: [],
            virtualExpRow: 0,
            newVirtualExpList: [],
            newVirtualExpCol: 0,
            news: [],
            notice: []
        };
    },
    created() {
        this.getVirtualExpList();
        this.getNewVirtualExpList();

        getFontendNewsList({
            center_id: process.env.VUE_APP_CENTER1_ID,
            page: 1,
            pagesize: 6
        }).then(res => {
            this.news = res.newsList;
            res.newsList.forEach(item => {
                    this.banner.push(item.logo);
            });
            
        });
        getFontendNoticeList({
            center_id: process.env.VUE_APP_CENTER1_ID,
            page: 1,
            pagesize: 6
        }).then(res => {
            this.notice = res.newsList;
        });
    },
    methods: {
        // 获取虚拟实验列表
        getVirtualExpList() {
            showVirtualSimulation({
                page: 1,
                showNum: 6,
                order: "expVisitCount"
            }).then(res => {
                res.virtualList.forEach(item => {
                    this.virtualExpList.push({
                        id: item.id,
                        imageUrl:
                            item.video_img ||
                            "http://sjjx.dlou.edu.cn/uploads/default.png",
                        title: item.exp_name || item.title,
                        school: item.school_name,
                        leader: item.fuzeren,
                        count: item.expVisitCount
                    });
                });
                this.virtualExpRow = parseInt(1 / 3) + 1;
                if (this.virtualExpRow > 2) {
                    this.virtualExpRow = 2;
                }
            });
        },
        // 获取最新虚拟实验列表
        getNewVirtualExpList() {
            showVirtualSimulation({
                page: 1,
                showNum: 3,
                order: "p1.id"
            }).then(res => {
                res.virtualList.forEach(item => {
                    this.newVirtualExpList.push({
                        id: item.id,
                        imageUrl:
                            item.video_img ||
                            "http://sjjx.dlou.edu.cn/uploads/default.png",
                        title: item.exp_name || item.title,
                        school: item.school_name,
                        leader: item.fuzeren,
                        count: item.expVisitCount
                    });
                });
                this.newVirtualExpCol = res.virtualList.length;
                if (this.newVirtualExpCol > 3) {
                    this.newVirtualExpCol = 3;
                }
            });
        },
        // 跳转
        handleGo(url) {
            let level = [],
                key = false;
                console.log(url);
            if (JSON.stringify(this.$store.state.userInfo) != "{}") {
               var levelstr=this.$store.state.userInfo.islogin+'';
                
                level = levelstr.split("");
                console.log(level);
            }
            
            if (url == "caselibrary") {
                key = true;
            } else if (url == "manager") {
                if (level[0] > 1) {
                    key = true;
                }
            } else if (url == "base") {
                if (level[2] > 1) {
                    key = true;
                }
            }

            if (key) {
                this.$router.push(`/${url}`);
            }else{
                
                this.$message({
                    message: '权限不符，请登录或联系管理员后重试',
                    type: 'warning'
                  });

            }
        }
    }
};
</script>

<style lang="scss" scoped>
.more-tools {
    width: 80%;
    margin: 6px 10% !important;

    &:first-child {
        margin-top: 0px !important;
    }
}

.ml-card {
    margin: 8px;
}
</style>
